export default class UnauthorizedError<Data = unknown> extends Error {
  name = 'UnauthorizedError';

  constructor(readonly message = 'Unauthorized Feature', readonly data?: Data) {
    super(message);
  }
}
